import { FilterGroup } from "./buildOncologySubmissionSearchFilters";

/** Default sort order for the oncology submission table API requests. */
export const ONCOLOGY_SUBMISSION_DEFAULT_ORDER_BY = [
  { column: "dumped_at", direction: "DESC" as const },
  { column: "patient_name", direction: "ASC" as const },
];

/** Request payload shape for oncology submission BigQuery table fetches. */
export interface OncologySubmissionFilterPayload {
  filters?:
    | {
        seq?: string[];
        dumped_at?: string[];
        [key: string]: any;
      }
    | FilterGroup;
  case_sensitive?: boolean;
  page: number;
  page_size?: number;
  request_id?: string;
  order_by?: { column: string; direction: "ASC" | "DESC" }[];
}
